import bulkInvoiceItemTypesUploadDetails from "./bulkInvoiceItemTypesUploadDetails.component";
import bulkInvoiceItemTypesUploadDetailsUrls from "./bulkInvoiceItemTypesUploadDetails.urls";
import BulkInvoiceItemTypesUploadDetailsTransforms from "./bulkInvoiceItemTypesUploadDetails.transforms";

const bulkInvoiceItemTypesUploadDetailsModule = angular
  .module("app.components.bulkInvoiceItemTypesUploadDetails", [])
  .component(
    "bulkInvoiceItemTypesUploadDetailsPage",
    bulkInvoiceItemTypesUploadDetails
  )
  .service(
    "BulkInvoiceItemTypesUploadDetailsTransforms",
    BulkInvoiceItemTypesUploadDetailsTransforms
  )
  .config(bulkInvoiceItemTypesUploadDetailsUrls);

export default bulkInvoiceItemTypesUploadDetailsModule;



// WEBPACK FOOTER //
// ./src/pages/bulkInvoiceItemTypesUploadDetails/bulkInvoiceItemTypesUploadDetails.module.js